import _ from 'lodash'
import { FETCH_LOCATION_SUB_CATEGORIES } from '../actions/types'

export default (state = [], action) => {
  switch (action.type) {
    case FETCH_LOCATION_SUB_CATEGORIES:
      return { ...state, [action.parent_id]: action.payload }
    default:
      return state
  }
}
